<template>
  <div class="content-block" :class="{ 'content-block_no-border': blokType === 'HyperText' }">
    <div
      class="content-block__item content-block__item_text"
      v-if="blokType === 'HyperText'"
    >
      <div class="content-block__delete" v-if="!demo">
        <ToolbarIcons
          type-img="trash"
          red
          @click="$emit('clickDelete')"
        />
      </div>
      <div class="content-block__editor editor">
        <CkeditorResizable :default-height="220" :min-height="120">
          <ckeditor
            :editor="editor"
            :model-value="blokText"
            :config="editorConfig"
            @input="$emit('onEditorInput', $event)"
          />
        </CkeditorResizable>
      </div>
    </div>
    <div
      class="content-block__item content-block__item_image carousel"
      v-if="blokType === 'Image'"
    >
      <div class="content-block__delete" v-if="!demo">
        <ToolbarIcons
          type-img="trash"
          red
          @click="$emit('clickDelete')"
        />
        <ToolbarIcons
          type-img="edit"
          @click="$emit('clickEdit', contentBlock)"
        />
      </div>
      <span
        :class="{
          'carousel__button carousel__button_right': true,
          'carousel__button_disabled': activeItem === images.length - 1
        }"
        @click="countActiveItem('increment')"
      >
        <i class="gg-chevron-right-o"></i>
      </span>
      <span
      :class="{
          'carousel__button carousel__button_left': true,
          'carousel__button_disabled': activeItem === 0
        }"
        @click="countActiveItem('decrement')"
      >
        <i class="gg-chevron-left-o"></i>
      </span>
      <div
        v-for="(item, idx) in images"
        :key="idx"
        :class="{
          'carousel__item': true,
          'carousel__item_active': idx === activeItem,
        }"
      >
        <img
          :src="envUrlBase + item.FilePath"
        />
        <div class="image-check-mark" v-if="frontImageId === item.FileId">
          <CheckMark />
        </div>
      </div>
    </div>
    <div
      class="content-block__item content-block__item_video"
      v-if="blokType === 'Video'"
    >
      <div class="content-block__delete" v-if="!demo">
        <ToolbarIcons
        type-img="trash"
        red
        @click="$emit('clickDelete')"
      />
      </div>
      <iframe
        :key="idx"
        width="60%"
        height="100%"
        :src="videoUrl"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'

import CheckMark from '@/components/icons/CheckMark.vue'
// import CloseIcon from '@/components/icons/CloseIcon.vue'
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import CkeditorResizable from '@/components/elements/CkeditorResizable.vue'

import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'FormContentBlock',
  components: {
    CheckMark,
    // CloseIcon,
    ToolbarIcons,
    CkeditorResizable
  },
  props: {
    frontImageId: {
      type: Number,
      default: 0
    },
    contentBlock: {
      type: Object,
      default: () => ({})
    },
    blokText: {
      type: String,
      default: ''
    },
    blokType: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => ([])
    },
    videoUrl: {
      type: String,
      default: ''
    },
    demo: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clickDelete', 'onEditorInput', 'clickEdit'],
  setup () {
    const envUrlBase = ref(null)

    // const envUrlBase = process.env.VUE_APP_URL_BASE + '/'

    const editorData = ref([])

    const editor = ref(Editor)

    const editorConfig = ref({})

    const activeItem = ref(0)

    onMounted(() => {
      if (localStorage.activeProject === 'site') {
        envUrlBase.value = process.env.VUE_APP_URL_BASE + '/'
      } else if (localStorage.activeProject === 'education') {
        envUrlBase.value = process.env.VUE_APP_URL_EDUCATION + '/'
      }
    })

    const countActiveItem = (type) => {
      type === 'increment' ? activeItem.value += 1 : activeItem.value -= 1
    }

    return {
      editorData,
      editor,
      editorConfig,
      envUrlBase,
      activeItem,
      countActiveItem
    }
  }
}
</script>
<style>
.editor ul {
  padding-left: 35px;
}
.editor ol {
  padding-left: 35px;
}
.editor {
  p, h1, h2, h3, h4, h5, h6 {
    text-indent: 15px;
  }
}
.editor li {
  list-style-type: inherit !important;
}
</style>

<style lang="scss" scoped>
.content-block {
  margin-bottom: 24px;
  border: 1px solid #000000;
  border-radius: 6px;

  &_no-border {
    border: none;
  }

  &__delete {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    z-index: 2;

    :deep(.wrapper-icon) {
      width: 24px;
      height: 24px;

      svg {
        width: 17px;
        height: 17px;
      }
    }
  }

  &__item {
    position: relative;
    //padding: 16px;
    background-color: #FFFFFF;
    //box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    &_image {
      height: 244px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &_video {
      height: 244px;
    }
  }

  &__editor, .editor {
    position: relative;
    max-width: 95%;
    // height: fit-content;
    border: 1px solid #000;
    cursor: text;
    border-radius: 6px;
    &.content-block {
      border: none;
    }
  }
}

.carousel {
  position: relative;

  &__button {
    position: absolute;
    top: 50%;
    cursor: pointer;

    &_left {
      left: 0;
    }

    &_right {
      right: 0;
    }

    &_disabled {
      display: none;
    }
  }

  &__item {
    display: none;
    width: 100%;
    height: 100%;

    &_active {
      display: block;
    }
  }
}

.image-check-mark {
  position: absolute;
  bottom: 6px;
  left: 6px;
}

.gg-chevron-right-o {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs,1));
  width: 22px;
  height: 22px;
  border: 2px solid;
  border-radius: 100px;
  color: #1ba6da;
  background-color: #00ABEC;
}
.gg-chevron-right-o::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 6px;
  height: 6px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  transform: rotate(-45deg);
  left: 5px;
  top: 6px;
  color: #FFFFFF;
}

.gg-chevron-left-o {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs,1));
  width: 22px;
  height: 22px;
  border: 2px solid;
  border-radius: 100px;
  color: #1ba6da;
  background-color: #1ba6da;
}
.gg-chevron-left-o::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 6px;
  height: 6px;
  border-bottom: 2px solid;
  border-left: 2px solid;
  transform: rotate(45deg);
  left: 7px;
  top: 6px;
  color: #FFFFFF;
}

:deep(.ck-editor__editable.ck-focused) {
  //border-color: #00ABEC !important;
}
:deep( .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused)) {
  border: none;
  border-radius: 6px !important;
}

:deep(.ck.ck-toolbar) {
  border: none;
  border-radius: 6px 6px 0px 0px!important;
  border-bottom: 1px solid #000000 !important;
}

:deep(.ck-button) {
  background-color: transparent;
  transition: background-color 0.2s;

  &:active,
  &.ck-on,
  &.ck-button_on {
    background-color: #0080B1 !important;
    color: #FFFFFF !important;

    svg,
    path {
      fill: #FFFFFF !important;
    }
  }

  // Если есть состояния с "pressed"
  &[aria-pressed="true"] {
    background-color: #0080B1 !important;
    color: #FFFFFF !important;

    svg,
    path {
      fill: #FFFFFF !important;
    }
  }
}
</style>
